import { render, staticRenderFns } from "./ChangelogSection.vue?vue&type=template&id=418f021f&scoped=true"
import script from "./ChangelogSection.vue?vue&type=script&lang=js"
export * from "./ChangelogSection.vue?vue&type=script&lang=js"
import style0 from "./ChangelogSection.vue?vue&type=style&index=0&id=418f021f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f021f",
  null
  
)

export default component.exports